function setAuthCookie(name, value, days) {
    console.log(value)
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + days);
  
      const secureCookie = process.env.NODE_ENV === 'production' ? '; Secure' : '';
      const cookieString = `${name}=${value}; expires=${expiryDate.toUTCString()}; path=/${secureCookie}; SameSite=Lax`;
      document.cookie = cookieString;
    }
  
    export default setAuthCookie;